<template>
  <editor-content class="textarea-main" :editor="editor" />
  <div v-if="isTools" class="textarea-tools">
    <button
      type="button"
      @click="editor.chain().focus().toggleBold().run()"
      :class="{ 'is-active': editor?.isActive('bold') }"
    >
      <img src="@/assets/images/bold.svg" alt="bold" />
    </button>
    <button
      type="button"
      @click="editor.chain().focus().toggleItalic().run()"
      :class="{ 'is-active': editor?.isActive('italic') }"
    >
      <img src="@/assets/images/italic.svg" alt="italic" />
    </button>
    <button
      type="button"
      @click="editor.chain().focus().toggleBulletList().run()"
      :class="{ 'is-active': editor?.isActive('bulletList') }"
    >
      <img src="@/assets/images/list.svg" alt="list" />
    </button>
    <button type="button" @click="editor.chain().focus().undo().run()">
      <img src="@/assets/images/undo.svg" alt="undo" />
    </button>
    <button type="button" @click="editor.chain().focus().redo().run()">
      <img src="@/assets/images/redo.svg" alt="redo" />
    </button>
  </div>
</template>
<script>
import { Editor, EditorContent } from '@tiptap/vue-3';
import Placeholder from '@tiptap/extension-placeholder';
import StarterKit from '@tiptap/starter-kit';

export default {
  components: {
    EditorContent,
  },
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    isTools: {
      type: Boolean,
      default: true,
    },
    placeholderValue: {
      type: String,
      default: '入力してください',
    },
  },
  data() {
    return {
      //   content: '',
      editor: null,
    };
  },
  watch: {
    modelValue(value) {
      const isSame = this.editor.getHTML() === value;
      if (isSame) {
        return;
      }
      this.editor.commands.setContent(value, false);
    },
  },
  mounted() {
    this.editor = new Editor({
      extensions: [
        StarterKit,
        Placeholder.configure({
          placeholder: this.placeholderValue,
        }),
      ],
      content: this.modelValue,
      onUpdate: () => {
        // HTML
        this.$emit('update:modelValue', this.editor.getHTML());
        // JSON
        // this.$emit('update:modelValue', this.editor.getJSON())
      },
    });
  },
  beforeUnmount() {
    this.editor.destroy();
  },
};
</script>
